import * as devisConf from '@/configuration/devisConf';
import store from '@/store/store';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import { getAll } from '@/api/produit/produitFace';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import validationLigneCommandeDemandeLogistique from '@/services/dcf/validation/validationLigneCommandeDemandeLogistique';
import { getMessageIndisoFaceInfo } from '@/services/dcf/reseauTempo/getMessageIndispoFace';

async function getListUsers() {
  await store.dispatch('parametres/loadParametreUtilisateur');
  const parametre = store.getters['parametres/parametre'];
  return parametre(PARAMETRES_KEYS.utilisateur);
}

export default async function validation(response, messages, dcf) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors || !dcf) {
    return;
  }

  let i18nType = '';
  switch (dcf.type) {
    case devisConf.TYPE_COMMANDE:
      i18nType = 'validationCommande';
      break;
    case devisConf.TYPE_DEVIS:
      i18nType = 'validationDevis';
      break;
    default:
      i18nType = '';
      break;
  }

  const users = await getListUsers();
  const idFaces = [];
  response.data.error.validationErrors.forEach((error) => {
    const message = error.message;
    if (message.indexOf('FACE_NOT_AVAILABLE') === 0) {
      const elements = message.split('|')[0].split('@');
      const lignesCommandeFind = dcf.lignesCommande.find((ligne) => {
        return ligne.produitId === elements[3] && ligne.ligneReseau
          && ligne.ligneReseau.anneeSemaine.toString() === elements[2];
      });
      if (!lignesCommandeFind) {
        messages.push({
          message: i18nType + '.faceNotAvailable',
        });
        return;
      }
      const referenceReseau = lignesCommandeFind.produit.reference;
      const idFace = elements[1];
      if (!idFaces.includes(idFace)) idFaces.push(idFace);
      const semaine = elements[2].substring(4, 6);
      messages.push({
        message: i18nType + '.faceNotAvailableInSelection',
        parametres: {
          face: '', reseau: referenceReseau, semaine: semaine, id: elements[1],
        },
      });
    }
    if (message.indexOf('AMOUNT_SELECTED_IS_GREATER_THAN_AMOUNT_WISH') === 0) {
      messages.push({
        message: i18nType + '.faceSelectGreaterThanFaceWish',
      });
    }
    if (message.indexOf('LINE_S_STATE_MUST_BE_BLOQUE') === 0) {
      messages.push({
        message: i18nType + '.lineMustBeBloque',
      });
    }
    if (message.indexOf('NO_CHANGE_PARUTION_IN_LIGNE_COMMANDE_WITH_ENCART_CHEMIN_FER') === 0) {
      messages.push({
        message: i18nType + '.parutionCheminDeFer',
      });
    }
    if (message.indexOf('ORDER_OR_QUOTE_MUST_BE_NOT_CANCEL') === 0) {
      messages.push({
        message: i18nType + '.devisCommandeNotCancel',
      });
    }
    if (message.indexOf('2_BILLBOARD_IN_SAME_DCF') === 0) {
      messages.push({
        message: i18nType + '.sameFaceInSameWeek',
      });
    }
    if (message.indexOf('NEGATIVE_NORMAL_COMMAND_LINE_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.negativeNormalCommandLineForbidden',
      });
    }
    if (message.indexOf('NEGATIVE_NORMAL_COMMAND_FORBIDDEN') === 0) {
      messages.push({
        message: i18nType + '.negativeNormalCommandForbidden',
      });
    }
    if (message.indexOf('LIGNE_COMMANDE_ACHAT_LIGNE_RAPPROCHE_MUST_BE_MODIFIED') === 0) {
      messages.push({
        message: i18nType + '.ligneCommandeAchatLigneRapprocheeMustBeModified',
      });
    }
    if (message.indexOf('INVALID_FOR_TVA') === 0) {
      messages.push({
        message: i18nType + '.tvaNotInRange',
        parametres: {
          tva: message.split('|')[0].split('@')[1],
        },
      });
    }
    const messageInfo = getMessageIndisoFaceInfo(message, users);
    if (messageInfo) messages.push(messageInfo);
  });
  validationLigneCommandeDemandeLogistique(response, messages);
  if (!idFaces || idFaces.length === 0) return;
  const faces = (await getAll({
    query: {
      produitsId: idFaces,
    },
    limit: NO_PAGINATION,
  })).data.result.items;
  messages.forEach((m) => {
    if (m.message !== i18nType + '.faceNotAvailableInSelection') return;
    const face = faces.find((f) => f.id === m.parametres.id);
    if (!face) return;
    m.parametres.face = face.reference;
  });
}
